import { FieldPath } from 'react-hook-form';

import { EventWizardStep } from './constants';
import { EventWizardFormValues } from './validation/schema';

export type EventWizardStepConfig = {
  step: EventWizardStep;
  i18nKey: string;
  formFields: FieldPath<EventWizardFormValues>[];
};

export const EVENT_WIZARD_STEP_CONFIGS: EventWizardStepConfig[] = [
  {
    step: EventWizardStep.EventDetails,
    i18nKey: 'eventDetails',
    formFields: ['name', 'description', 'schedule', 'hosts', 'eventImage', 'sponsors'],
  },
  {
    step: EventWizardStep.NattersSetup,
    i18nKey: 'nattersSetup',
    formFields: ['nattersSetup.topics'],
  },
  {
    step: EventWizardStep.Tags,
    i18nKey: 'tags',
    formFields: ['tagCategories'],
  },
  {
    step: EventWizardStep.EntrySurvey,
    i18nKey: 'entrySurvey',
    formFields: ['entrySurvey.questions'],
  },
  {
    step: EventWizardStep.ExitSurvey,
    i18nKey: 'exitSurvey',
    formFields: ['exitSurvey.questions'],
  },
];
